import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'nav-item-fornecedor',
  template: `<section>
  <div fxLayout="row">
  <div class="img-fornecedor" *ngIf="item.img>''" >
       <download-img [width]="80" [height]="40" [src]="item.img">
       </download-img> 
  </div>
  <div [hidden]="!visible">
     {{text}}
  </div>
  </div></section>
  `,
  styleUrls: []
})
export class NavitemFornecedor implements OnInit {
  @Output() click = new EventEmitter();

  ftext = '';
  fvalue = {};
  findex = -1;
  finfo ="";
  fvisible = true;
  @Input()
  item:any={};
  constructor() { }

  ngOnInit() {
  }

  doClick(item) {
    if (item != null) {
      this.click.emit(item)
    } else
      this.click.emit(this.fvalue);
  }

  @Input()
  get text() {
    return this.ftext;
  }
  set text(v) {
    this.ftext = v;
  }

  @Input()
  get value() {
    return this.fvalue;
  }
  set value(v) {
    this.fvalue = v;
  }

  @Input()
  get index() {
    return this.findex;
  }
  set index(v) {
    this.findex = v;
  }
  
  @Input()
  get info(){
    return this.finfo;
  }
  set info(v){
    this.finfo = v;
  }

  showInfo() {
    alert(this.finfo);
  }
  
  @Input()
  get visible(){
    return this.fvisible;
  }
  
  set visible(v){
    this.fvisible = v;
  }

}
